var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoFee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 77,
    viewBox: "0 0 73 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.9823 49.993C61.9967 66.7402 43.3889 76.1218 27.2521 73.5912C24.6262 73.1794 17.4277 71.9528 11.0542 66.1657C-1.21503 55.0251 -3.83905 32.9654 6.05826 17.4193C13.2618 6.1045 26.1745 -0.309274 38.4443 0.0114828C41.0871 0.0806602 51.2159 0.506533 60.1174 7.97986C61.4248 9.07751 64.3086 11.686 66.9074 15.8239C73.01 25.5409 73.5347 39.0786 68.982 49.993H68.9823Z",
    fill: "#E55C73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73.5C60.3789 73.5 61.7443 73.2284 63.0182 72.7007C64.2921 72.1731 65.4496 71.3996 66.4246 70.4246C67.3996 69.4496 68.1731 68.2921 68.7007 67.0182C69.2284 65.7443 69.5 64.3789 69.5 63C69.5 61.6211 69.2284 60.2557 68.7007 58.9818C68.1731 57.7079 67.3996 56.5504 66.4246 55.5754C65.4496 54.6004 64.2921 53.8269 63.0182 53.2993C61.7443 52.7716 60.3789 52.5 59 52.5C56.2152 52.5 53.5445 53.6062 51.5754 55.5754C49.6062 57.5445 48.5 60.2152 48.5 63C48.5 65.7848 49.6062 68.4555 51.5754 70.4246C53.5445 72.3938 56.2152 73.5 59 73.5Z",
    fill: "#E55C73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.201 58.7998L54.8008 67.2M54.8008 58.7998L63.201 67.2L54.8008 58.7998Z",
    stroke: "white",
    strokeWidth: 1.26003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 21.75L50.25 50.25",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 24.917H45.5C46.7598 24.917 47.968 25.4174 48.8588 26.3082C49.7496 27.199 50.25 28.4072 50.25 29.667V42.3337C50.25 42.8007 50.1819 43.2647 50.0473 43.7112",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8775 46.8851C46.4308 47.02 45.9666 47.0883 45.5 47.0878H26.5C25.2402 47.0878 24.032 46.5873 23.1412 45.6965C22.2504 44.8057 21.75 43.5976 21.75 42.3378V29.6711C21.7497 28.6533 22.0764 27.6624 22.6819 26.8443C23.2873 26.0262 24.1396 25.4241 25.113 25.127",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 34.417H34.4167",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 34.417H50.25",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.084 40.75H28.0998",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.416 40.75H37.5827",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFee);
export default __webpack_public_path__ + "static/media/no_fee.3a646a24387c967cd36b1d28900618f2.svg";
export { ForwardRef as ReactComponent };